const TEMPLATE = `
<section class="maps container-fluid fade-up" mb-accordion>
    <div class="row">
        <div class="col-md-6">
            <p class="section-label" data-animate-child>Контакти та локації</p>
        </div>
        <div class="col-md-6">
            <h3 data-animate-child>
                Завжди на зв'язку для вас
            </h3>
            <p data-animate-child>Якщо у вас виникають питання щодо діагностики, партнерства чи клінічної співпраці
                — зв'яжіться з нами. Команди BML у Києві та Львові готові надати оперативну й точну підтримку.</p>
        </div>
    </div>
    <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
        <div class="row">
            <div class="col-md-6 d-flex justify-content-between">
                <h4 data-animate-child>BML Київ</h4>
                <div class="col-md-2 d-md-none justify-content-end">
                    <img class="open-accordion" src="/images/button-close-accordion.svg"
                         alt="close-accordion-btn" data-animate-child>
                    <img class="close-accordion" src="/images/button-open-accordion.svg"
                         alt="open-accordion-btn" data-animate-child>

                </div>
            </div>
            <div class="col-md-6">

                <div class="row">
                    <div class="col-md-6 col-6 data-for-contacts">
                        <ul data-animate-child>
                            <li><a href="tel:+380443334308">+38 044 333 43 08</a></li>
                            <li><a href="mailto:info@bogomoletslab.com">info@bogomoletslab.com</a></li>
                        </ul>
                    </div>
                    <div class="col-md-6 col-6 address-info">
                        <div class="row">
                            <div class="col-md-10">
                                <ul data-animate-child>
                                    <li>бул. Т.Шевченка, 26/4-Б</li>
                                </ul>
                            </div>
                            <div class="col-md-2 d-none d-md-flex justify-content-end">
                                <img class="open-accordion" src="/images/button-close-accordion.svg"
                                     alt="close-accordion-btn" data-animate-child>
                                <img class="close-accordion" src="/images/button-open-accordion.svg"
                                     alt="open-accordion-btn" data-animate-child>

                            </div>
                        </div>

                    </div>

                </div>
            </div>


        </div>
        <div class="accordion-inner map-container">
            <div id="map"></div>
        </div>
    </div>
    <div class="accordion-main accordion-map container-fluid" data-animate-child>
        <div class="row">
            <div class="col-md-6 d-flex justify-content-between">
                <h4 data-animate-child>BML Львів</h4>
                <div class="col-md-2 d-md-none justify-content-end">
                    <img class="open-accordion" src="/images/button-close-accordion.svg"
                         alt="close-accordion-btn" data-animate-child>
                    <img class="close-accordion" src="/images/button-open-accordion.svg"
                         alt="open-accordion-btn" data-animate-child>

                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6 col-6 data-for-contacts">
                        <ul data-animate-child>
                            <li><a href="tel:+380443334308">+38 044 333 43 08</a></li>
                            <li><a href="mailto:info@bogomoletslab.com">info@bogomoletslab.com</a></li>
                        </ul>
                    </div>
                    <div class="col-md-6 col-6 address-info">
                        <div class="row">
                            <div class="col-md-10">
                                <ul data-animate-child>
                                    <li>вул. Стрийська, 33</li>
                                </ul>
                            </div>
                            <div class="col-md-2 d-none d-md-flex justify-content-end">
                                <img class="open-accordion" src="/images/button-close-accordion.svg"
                                     alt="close-accordion-btn" data-animate-child>
                                <img class="close-accordion" src="/images/button-open-accordion.svg"
                                     alt="open-accordion-btn" data-animate-child>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion-inner map-container">
            <div id="map-lviv" data-animate-child></div>
        </div>
    </div>
</section>
`;

class BmlContactMaps extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-contact-maps', BmlContactMaps);
